import React from "react";
import {
  Row,
  Card,
  CardBody,
  Col
} from "reactstrap";
import "./vista-reportes.view.scss";
import { DataService } from "../../services/data.service";
class VistaReportes extends React.Component {
  constructor(props) {
    super(props);
    let me = this;
    this.state = {
      data: []
    };
  }
  componentDidMount() {
    let me = this;
    me.mounted = true;
    me.processingData();
  }
  componentWillUnmount() {
    let me = this;
    me.mounted = false;
  }
  processingData() {
    let me = this;
    DataService.getData(
      {
        query: "SNA10",
      },
      function (result) {
        if (me.mounted)
          me.setState({
            data: result.SNA10.data
          });
      }
    );
  }
  render() {
    const {
      data
    } = this.state;
    return (
      <div>
        <Row className="no-gutters">
          <Col>
            <Card className="header-toolbar-menu">
              <CardBody className="text-center">
                <span className="text-white  header-toolbar-menu-text-size">
                  Reportes regionales
                </span>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          {data.map((region, index) => (
            <Col key={index} xs="12" sm="6" md="4" lg="3">
              <div className="card-dosier">
                <div className="card-dosier__title">{region.nombre}</div>
                <div className="card-dosier__image-container">
                  <img src={`${region.url_portada}`} alt="Reportes" />
                </div>
                <div className="dosier__date">{region.fecha_mes}{" "}{region.fecha_anio}</div>
                <a
                  href={`${region.url_reporte}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary btn-sm"
                >
                  Descargar
                </a>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    );
  }
  onPeriodoChange = selection => {
    this.setState({ periodo: selection });
  };
}
export default VistaReportes;
